import { useFormContext } from 'react-hook-form'
import { splitStringByLength } from 'src/utils/StringUtil'
import { InvoiceFormInputs } from '../InvoiceEditForm'
import { INVOICE_PREVIEW_COLS_AT_ROW } from '../InvoiceRemarks'

export const Remarks: React.FC = () => {
  const { watch } = useFormContext<InvoiceFormInputs>()
  const remarks = watch('remarks')
  const items = watch('items')
  const baseYPosition =
    items.length >= 16
      ? 60 + 24 * 4 + 20 + 68 + 18 + 10 + items.slice(16, 30).length * 24
      : items.length >= 13
      ? 60 + 24 * 4 + 20 + 68 + 18 + 10
      : items.length >= 8
      ? 60 + 68 + 18 + 10
      : items.length >= 5
      ? 60
      : 352.5 + Math.max(0, items.length - 4) * 24 + 24 * 4 + 8 + 68 + 18 + 10
  return (
    <>
      <text
        x="36"
        y={baseYPosition + 12}
        fill="#0D0D0D"
        fontSize={'10px'}
        fontWeight={'bold'}
      >
        備考
      </text>
      <rect
        x="36"
        y={baseYPosition + 20}
        width="428"
        height="68"
        rx="2"
        fill="#F8F8F8"
      />

      {remarks
        .split('\n')
        .flatMap((row) => splitStringByLength(row, INVOICE_PREVIEW_COLS_AT_ROW))
        .map((row, i) => {
          return (
            <text
              x="42"
              y={baseYPosition + 38 + 14 * i}
              fill="#0D0D0D"
              fontSize={'10px'}
              key={i}
            >
              {row}
            </text>
          )
        })}
    </>
  )
}
